import React from "react";
import {observable, toJS} from 'mobx';
import {observer} from 'mobx-react';

import {TreeSelect} from 'antd';

import MyAgentStore from '@store/LoginUser/MyAgentStore';
import WalletHistoryFilterForm from "../Statistic/WalletHistory/WalletHistoryFilterForm";



@observer
class MyAgentTreeSelect extends React.Component {

  @observable
  resultList = [];


  render() {

    let result = toJS(MyAgentStore.agentTreeList);

    return (
      <TreeSelect
        showSearch
        treeDefaultExpandAll
        style={this.props.style}
        defaultValue={this.props.defaultValue}
        placeholder="请选择代理"
        size={'small'}
        onSelect={this.props.onSelect}
        onChange={this.props.onChange}
        allowClear
        treeData={result}
      >
      </TreeSelect>
    )

  }
}

export default MyAgentTreeSelect;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Common/MyAgentTreeSelect.jsx